type LocationLike = Pick<Location, 'replace' | 'assign'>;

export const locationProvider = {
  get(): LocationLike {
    return window.location;
  },
};

export function replaceLocation(path: string) {
  locationProvider.get().replace(path);
}

export function assignLocation(path: string) {
  locationProvider.get().assign(path);
}

